import React from "react";
import './Home.css';

import awards from './img/Most Awarded_Banner.webp'
import awardsmob from './img/Most Awarded_Mobile.webp'
import Fibreglass from "./Fibreglass_Swimming_Pool";
import AusNetwork from "./AT_Australia_Network";
import Slider from "./Slider_steps";
import './Media.css';
function Home() {
    return (
        <>
            <Fibreglass />
            <div className="awardPanel">
                {/* <div className="award-col-left"><h2>Australia’s most awarded pool company</h2></div> */}
                <div className="award-col-right"><img src={awards} className="award" width="1710" height="198" loading="lazy" decoding="async" alt="Australia’s most awarded pool company" /></div>
            </div>
             <div className="awardPanel-mob">
                {/* <div className="award-col-left"><h2>Australia’s most awarded pool company</h2></div> */}
                <div className="award-col-right"><img src={awardsmob} className="awardmob" width="1155" height="330" loading="lazy" decoding="async" alt="Australia’s most awarded pool company" /></div>
            </div>


            <AusNetwork />


            <Slider />

        </>
    )
}

export default Home;
